import { FloorPlanAreaType } from '../../models/vitality-tracker';
import { AnimalActivity } from './types';
import { useEffect, useRef } from 'react';

export class ChartHelpers {
  static colors = ['#999999', '#9C27B0', '#2196F3', '#4CAF50', '#FF9800', '#3F51B5', '#FFEB3B', '#00BCD4'];

  static getActivitiesWithColors(): AnimalActivity[] {
    return Object.keys(FloorPlanAreaType)
      .filter((v) => isNaN(Number(v)))
      .map((key: string, index: number) => {
        return {
          key: key,
          value: FloorPlanAreaType[Number(key)],
          color: this.colors[index],
          isSelected: true
        };
      });
  }

  static getUuid() {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c: any) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
  }
}

export const usePrevious = <T extends unknown>(value: T): T | undefined => {
  const ref = useRef<T>(undefined as unknown as T);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
